import {
  Badge,
  BreadcrumbButton,
  BreadcrumbItem,
  ToggleButton,
  Tooltip,
} from "@fluentui/react-components";
import {
  PeopleSettingsRegular,
  ServiceBellRegular,
} from "@fluentui/react-icons";
import { Flex } from "components/styled";
import { useAtom } from "jotai";
import { ROUTES } from "library/constants";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { pageVisitedBeforeNeedsAttentionState } from "store/UIHrPage";

type Props = {
  count: number;
};

const NeedsAttentionButton = ({ count }: Props) => {
  const { t } = useTranslation();
  const [pageVisitedBeforeNeedsAttention, setPageVisitedBeforeNeedsAttention] =
    useAtom(pageVisitedBeforeNeedsAttentionState);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === ROUTES.NEEDS_ATTENTION &&
      pageVisitedBeforeNeedsAttention === null
    ) {
      setPageVisitedBeforeNeedsAttention(ROUTES.HR);
    }

    if (
      location.pathname !== ROUTES.NEEDS_ATTENTION &&
      pageVisitedBeforeNeedsAttention !== null
    ) {
      setPageVisitedBeforeNeedsAttention(null);
    }
  }, [pageVisitedBeforeNeedsAttention, location]);

  return (
    <Flex gap={"10px"}>
      {pageVisitedBeforeNeedsAttention !== null && (
        <BreadcrumbItem>
          <BreadcrumbButton
            icon={<PeopleSettingsRegular />}
            onClick={() => {
              navigate(`${ROUTES.HR}`, {});
            }}
          >
            {t("hbh.hr.label")}
          </BreadcrumbButton>
        </BreadcrumbItem>
      )}

      <Tooltip content={t("hbh.needsAttention.label")} relationship="label">
        <div style={{ position: "relative", display: "inline-block" }}>
          <ToggleButton
            icon={<ServiceBellRegular />}
            appearance="subtle"
            checked={pageVisitedBeforeNeedsAttention !== null}
            onClick={() => {
              if (pageVisitedBeforeNeedsAttention === null) {
                setPageVisitedBeforeNeedsAttention(location.pathname);
                navigate(`${ROUTES.NEEDS_ATTENTION}`);
              } else {
                const prevPage = pageVisitedBeforeNeedsAttention;
                setPageVisitedBeforeNeedsAttention(null);
                navigate(`${prevPage}`);
              }
            }}
          />
          {count > 0 && (
            <Badge
              appearance="filled"
              color="danger"
              size="small"
              style={{
                position: "absolute",
                top: 4,
                right: 4,
                transform: "translate(50%, -50%)",
              }}
            >
              {count}
            </Badge>
          )}
        </div>
      </Tooltip>
    </Flex>
  );
};

export default NeedsAttentionButton;
